import { render, staticRenderFns } from "./companies.vue?vue&type=template&id=61007f6e"
import script from "./companies.vue?vue&type=script&lang=ts"
export * from "./companies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports